import React from 'react';
import { Collapse } from 'react-bootstrap';
import { addCommas, removeNonNumeric } from '@helper';
import { useStore } from '@store';
import { observer } from 'mobx-react-lite';
import classNames from 'classnames';
import { companyTypes } from '../../containers/Loan/constant/loan.js';

const CustomerInfo = ({ title }) => {
    const {
        AuthStore: {
            name,
            account,
            borrowedAmount,
            maintenanceRatio,
            financingLimit,
            borrowingAmount,
            open,
            updateData,
            bhno,
            queryTime,
            updateUserInfo,
        },
    } = useStore();
    const waveAmount = borrowingAmount / financingLimit;
    const waveLevel = classNames({
        '': waveAmount === 0,
        'wa-1': waveAmount < 0.2 && waveAmount >= 0.1,
        'wa-2': waveAmount < 0.3 && waveAmount >= 0.2,
        'wa-3': waveAmount < 0.4 && waveAmount >= 0.3,
        'wa-4': waveAmount < 0.5 && waveAmount >= 0.4,
        'wa-5': waveAmount < 0.6 && waveAmount >= 0.5,
        'wa-6': waveAmount < 0.7 && waveAmount >= 0.6,
        'wa-7': waveAmount < 0.8 && waveAmount >= 0.7,
        'wa-8': waveAmount < 0.9 && waveAmount >= 0.8,
        'wa-9': waveAmount < 1 && waveAmount >= 0.9,
        'wa-10': waveAmount >= 1,
    });

    return (
        <div>
            <div className="mo-caption  my-3  d-lg-none text-white">
                <h2 className="m-title d-inline">{title}</h2>
                <span
                    className={`m_rotate small rounded-pill float-end ${
                        !open ? '' : 'collapsed'
                    }`}
                    onClick={() => updateData('open', !open)}
                >
                    收合資訊
                    <i className=" bi-chevron-up" />
                </span>
            </div>
            <Collapse in={open}>
                <div id="top-infobox">
                    <div className="card top-infobox wow fadeInDown">
                        <div className="card-body position-relative">
                            <div className="left-info float-start">
                                <div className="row">
                                    <div className="info-member desk-show col-md-6">
                                        <p className="user-name text-black2 d-inline-block ">
                                            <i className="icon_user  d-inline-block align-top" />
                                            {name}
                                        </p>
                                        <span>
                                            {companyTypes
                                                .filter(
                                                    item => item.bhno === bhno
                                                )
                                                .map(item => item.label) +
                                                account}
                                        </span>
                                    </div>
                                    <div
                                        className="search-time d-flex justify-content-lg-end align-items-lg-end col-md-6"
                                        onClick={() => {
                                            updateUserInfo();
                                        }}
                                    >
                                        <i className="icon-reflash bi-arrow-clockwise" />
                                        <i className="icon-reflash" />
                                        查詢時間：{queryTime}
                                        <span className="ps-1">
                                            {/* {queryTime.split('T')[1]} */}
                                        </span>
                                    </div>
                                    <div className="info-box col-md-4">
                                        <div className="d-flex">
                                            <i className="icon-f1" />
                                            <div className="info-stats mb-1 mb-md-0">
                                                <h6>尚可借金額</h6>
                                                <h2 className="price fw-bolder text-break">
                                                    <span>$</span>
                                                    {addCommas(
                                                        // removeNonNumeric(
                                                        borrowedAmount
                                                        // )
                                                    )}
                                                </h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="info-box col-md-4 d-none d-md-block">
                                        <div className="d-flex">
                                            <i className="icon-f2" />
                                            <div className="info-stats">
                                                <h6>擔保品融通額度</h6>
                                                <h2 className="price fw-bolder">
                                                    <span>$</span>
                                                    {addCommas(
                                                        removeNonNumeric(
                                                            financingLimit
                                                        )
                                                    )}
                                                </h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="info-box col-md-4 mb-3 mb-lg-0">
                                        <div className="d-flex">
                                            <i className="icon-f3" />
                                            <div className="info-stats d-flex d-md-block align-items-center">
                                                <h6 className="px-2 px-md-0 me-2">
                                                    維持率
                                                </h6>
                                                <h2 className="price fw-bolder text-break me-2">
                                                    {maintenanceRatio}
                                                    <span>%</span>
                                                </h2>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="loan_box position-absolute">
                                <div className="wave-container d-flex justify-content-around m-md-auto position-relative rounded-circle">
                                    <div
                                        className={
                                            waveLevel === 'wa-10'
                                                ? 'text-white info-stats align-self-center text-center'
                                                : 'info-stats align-self-center text-center'
                                        }
                                    >
                                        <h6>已借金額</h6>
                                        <h2
                                            className={
                                                waveLevel === 'wa-10'
                                                    ? 'text-white fs-6 fw-bolder mt-1'
                                                    : 'price fw-bolder mt-1'
                                            }
                                        >
                                            <span>$</span>
                                            {addCommas(
                                                removeNonNumeric(
                                                    borrowingAmount
                                                )
                                            )}
                                        </h2>
                                    </div>
                                    <div
                                        className={`wave ${waveLevel} position-absolute overflow-hidden rounded-circle`}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Collapse>
        </div>
    );
};

export default observer(CustomerInfo);
